const userTypes = {
    new: "NEW",
    returning: "RETURNING"
  };
  
  export default userTypes;
  